import EthereumConfig from "../../tokens/ethereum.js";
export class EthereumEthersV5 extends EthereumConfig {
}
//# sourceMappingURL=ethersv5.js.map